import $ from "jquery";
import { resizeTasks } from "DMS/Controllers/planningController";
export function resizeScreen() {
    // Height
    let height = $(window).outerHeight();
    // On adapte la taille de tous les éléments nécessaires
    $.each($(".resizable"), (key, item) => parseResizable(item, height));
}
export function onWindowResize() {
    // we don't resize the screen (including reloading kendo lists)
    // if the user is uploading a file :
    // problem with android 11 tablets : a resize event is sent
    // when the file choosing buttons are shown.
    if (!$("#uploadFile").length) {
        resizeScreen();
        launchOnHeightResized();
        resizeTasks();
    }
}
let timeoutOnHeightResized;
let startHeight; // = $(window).height();
//Fonction permetant du code à la fin d'un changement de hauteur de fenetre
export function launchOnHeightResized() {
    //A chaque appel on annule le timeout de la fonction
    clearTimeout(timeoutOnHeightResized);
    timeoutOnHeightResized = setTimeout(function () {
        //Si on arrive la c'est que cette fonction n'a pas été annulé
        // dans le temps impartit
        //Definition de la nouvelle
        // hauteur.
        startHeight = $(window).height();
        //// On place ici tous code devant etre appeler a la fin d'un resize de la hauteur de la fenetre
        resizeScreenKendo();
    }, 150);
}
/**
 * Fonction permettant de definir la hauteur max d'un element en fonction
 *  de la hauteur passée en parametre
 * @param {type} item Element à analyser
 * @param {int} height Hauteur
 */
function parseResizable(item, height) {
    var top = $(item).offset().top;
    if (top !== 0) {
        var footer = $('.navbar-fixed-bottom').height();
        var newHeight = height - top - 30 - footer;
        $(item).css('height', newHeight + 'px');
    }
}
//# sourceMappingURL=resizeScreen.js.map